import React from 'react';
import UIComponent from './ui_component.js';
import { withStyles } from 'material-ui/styles';
import UIDate from './date.js';
import UINumber from './number.js';
import UIDuration from './duration.js';

const styles = theme => ({
	title : {
		fontWeight: 'bold',
	},
	data : {
		marginLeft: 3,
	},
});

class UITuple extends UIComponent { 
  render() {
    var value, title;
    if(this.props.tuple){
      value = (this.props.tuple.value && this.props.tuple.value !== '') ? this.props.tuple.value : null;
      title = this.props.tuple.title;
    } else {
      value = (this.props.data) ? this.props.data : null;
      title = this.props.title;      
    }

  	if(value === null || value === '') return "";

  	const css = (this.props.className) ? this.props.className : '';

    if(Array.isArray(value)){
      return this.renderValues(title, value, css);
    } else {
      return this.renderValue(title, value, css);
    }   
  }

  renderValue(title, value, css){
    const classes = this.props.classes;
    return (
      <span className={css}>
        {title !== "" && 
          <span className={classes.title}>{title}:</span>
        }
        <span className={classes.data}>{this.formatValue(value)}</span>
      </span>
    );
  }

  renderValues(title, values, css){
    const classes = this.props.classes;
    var key = 0;
    return (
      <span className={css}>
        <span className={classes.title}>{title}:</span>
        <br/>
        {values.map(value =>
          <div key={key++}><span className={classes.data}>{this.formatValue(value)}</span></div>
        )}
      </span>
    );
  }

  formatValue(value){
    if(this.props.format){
      switch(this.props.format){
        case "date":
          value = <UIDate value={value}/>;
          break;
        case "number":
          value = <UINumber value={value}/>;
          break;
        case "duration":
          value = <UIDuration value={value}/>;
          break;
      }
    }

    if(this.props.link){
      value = <a href={this.props.link}>{value}</a>;
    }

    return value;
  }
}


export default withStyles(styles)(UITuple);


// WEBPACK FOOTER //
// ./src/core/ui/tuple.js